var map = {
	"./about-bg.png": 7631,
	"./advantages-1-1.png": 2937,
	"./advantages-1-2.png": 7864,
	"./advantages-2-1.png": 2363,
	"./advantages-2-2.png": 7772,
	"./advantages-3-1.png": 8726,
	"./advantages-3-2.png": 2233,
	"./arrow-hovered.jpg": 6746,
	"./arrow-hovered.png": 4824,
	"./assistant/assistant.jpg": 126,
	"./baner-BMA.jpg": 5010,
	"./baner-EasyBoard-2.jpg": 7069,
	"./banner2-bg.jpg": 2107,
	"./billboard.png": 9348,
	"./bma.jpg": 3096,
	"./board-template1.png": 674,
	"./board-template2.png": 1266,
	"./board-template3.png": 4130,
	"./board-template4.png": 1283,
	"./board-type.png": 5730,
	"./board1.jpg": 3164,
	"./board1.png": 9678,
	"./board2.jpg": 4993,
	"./board2.png": 3244,
	"./button-next.jpg": 2245,
	"./button-next.png": 3632,
	"./button-prev.jpg": 8093,
	"./button-prev.png": 4929,
	"./citylight.png": 4186,
	"./disabled.jpg": 7003,
	"./disabled.png": 4040,
	"./easyboard/easyboardImage.jpg": 4492,
	"./empty-divider-bg.png": 9934,
	"./gatsby-astronaut.png": 9697,
	"./gatsby-icon.png": 2329,
	"./homepage-banner.jpg": 5684,
	"./logo-black.png": 3813,
	"./logo-color.png": 2468,
	"./main-page-bg.jpg": 9185,
	"./mockups/image33.png": 5415,
	"./mockupsProPage.jpg": 6860,
	"./mockupsProPagePlanner.jpg": 890,
	"./mockupsProPagePlanner2.jpg": 2362,
	"./modal-board.jpg": 6160,
	"./news1.png": 1922,
	"./news2.jpg": 4569,
	"./news3.jpg": 1502,
	"./news4.jpg": 3563,
	"./newsItem-image-1.jpg": 5666,
	"./newsItem-image-2.jpg": 4705,
	"./partner1.jpg": 6624,
	"./partner1.png": 6464,
	"./partner2.jpg": 7066,
	"./partner2.png": 4673,
	"./partner3.jpg": 679,
	"./partner3.png": 3551,
	"./partner4.jpg": 1880,
	"./partner4.png": 4222,
	"./partner5.jpg": 8194,
	"./partner5.png": 5161,
	"./partners-bg.png": 9562,
	"./pepsi-stop.png": 7171,
	"./pf1.jpg": 9645,
	"./pf2.jpg": 9277,
	"./planner-bg.png": 6436,
	"./port1.jpg": 467,
	"./port2.jpg": 96,
	"./port3.jpg": 7198,
	"./port4.jpg": 4459,
	"./port5.jpg": 9272,
	"./port6.jpg": 4560,
	"./proj1.jpg": 5746,
	"./proj2.jpg": 2115,
	"./proj3.jpg": 2612,
	"./proj4.jpg": 8045,
	"./social-medias-bg.png": 3179,
	"./social1.png": 5650,
	"./social2.png": 4915,
	"./social3.png": 6167,
	"./social4.png": 6340,
	"./sponsor1.png": 5691,
	"./sponsor2.png": 369,
	"./sponsor3.png": 7682,
	"./sponsor4.png": 7442,
	"./sponsor5.png": 1000,
	"./stop1.png": 8085,
	"./stop2.png": 1887,
	"./stop3.png": 1623,
	"./worker1.jpg": 1423,
	"./worker2.jpg": 8115,
	"./worker3.jpg": 9292,
	"./worker4.jpg": 1655,
	"./worker5.jpg": 4577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;